import React from 'react';
import { Tooltip } from 'antd';
import classnames from 'classnames';
import IconCard from '@web-common/components/UI/IconCard/index';
import style from './index.module.scss';
const formatBreadName = (val, maxLength = 10) => {
    if (val.length > maxLength) {
        return React.createElement(Tooltip, { title: val }, `${val.slice(0, 5)}...${val.slice(-5)}`);
    }
    return val;
};
const BreadComp = ({ bread, ellipsisIndex, setCurrentDirId, maxLength = 10, highlightColor = '#262A33' }) => {
    const changeBread = item => {
        setCurrentDirId(item.id, item.name);
    };
    if (!bread) {
        return null;
    }
    return (React.createElement("div", { className: style.breadComp }, bread.map((item, index) => {
        const lastBreadcrumb = index === bread.length - 1;
        const clickBreadcrumb = () => {
            changeBread(item);
        };
        return lastBreadcrumb ? (React.createElement("div", { className: classnames(style.item, style.lastBread), key: item.id, onClick: clickBreadcrumb }, bread.length < 2 ? item.name : formatBreadName(item.name, maxLength))) : (React.createElement("div", { className: classnames(style.item, style.bread), key: item.id, onClick: clickBreadcrumb },
            ellipsisIndex.includes(index) ? '...' : formatBreadName(item.name, maxLength),
            React.createElement(IconCard, { type: "arrowRight", style: { width: '12px', height: '12px', margin: '0 6px' } })));
    })));
};
export default BreadComp;
